"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseSubscrbersApiResponse = void 0;
const parseSettings_1 = require("./parseSettings");
function parseSubscrbersApiResponse(response) {
    const parsedSubscribers = response.subscribers.map((apisubscribers) => {
        return {
            subscriber: apisubscribers.subscriber,
            settings: apisubscribers.settings ? (0, parseSettings_1.parseSettings)(apisubscribers.settings) : null
        };
    });
    return {
        itemcount: response.itemcount,
        subscribers: [...parsedSubscribers]
    };
}
exports.parseSubscrbersApiResponse = parseSubscrbersApiResponse;
//# sourceMappingURL=parseSubscribersAPI.js.map